/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PropertyFromJsonSchema } from './PropertyFromJsonSchema';
import {
    PropertyFromJsonSchemaFromJSON,
    PropertyFromJsonSchemaFromJSONTyped,
    PropertyFromJsonSchemaToJSON,
} from './PropertyFromJsonSchema';
import type { PropertyFromUISchema } from './PropertyFromUISchema';
import {
    PropertyFromUISchemaFromJSON,
    PropertyFromUISchemaFromJSONTyped,
    PropertyFromUISchemaToJSON,
} from './PropertyFromUISchema';

/**
 * A property definition containing jsonSchema and uiSchema values for the property
 * @export
 * @interface MetadataSchemaProperty
 */
export interface MetadataSchemaProperty {
    /**
     * 
     * @type {PropertyFromJsonSchema}
     * @memberof MetadataSchemaProperty
     */
    propertyFromJsonSchema: PropertyFromJsonSchema;
    /**
     * 
     * @type {PropertyFromUISchema}
     * @memberof MetadataSchemaProperty
     */
    propertyFromUISchema?: PropertyFromUISchema;
}

/**
 * Check if a given object implements the MetadataSchemaProperty interface.
 */
export function instanceOfMetadataSchemaProperty(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "propertyFromJsonSchema" in value;

    return isInstance;
}

export function MetadataSchemaPropertyFromJSON(json: any): MetadataSchemaProperty {
    return MetadataSchemaPropertyFromJSONTyped(json, false);
}

export function MetadataSchemaPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetadataSchemaProperty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'propertyFromJsonSchema': PropertyFromJsonSchemaFromJSON(json['propertyFromJsonSchema']),
        'propertyFromUISchema': !exists(json, 'propertyFromUISchema') ? undefined : PropertyFromUISchemaFromJSON(json['propertyFromUISchema']),
    };
}

export function MetadataSchemaPropertyToJSON(value?: MetadataSchemaProperty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'propertyFromJsonSchema': PropertyFromJsonSchemaToJSON(value.propertyFromJsonSchema),
        'propertyFromUISchema': PropertyFromUISchemaToJSON(value.propertyFromUISchema),
    };
}

